/* Solvea — scripts globaux chargés par theme.liquid.
   1) Tiroir panier : le HTML du tiroir est injecté/remplacé par innerHTML, ses scripts inline ne s'exécutent jamais → écouteurs délégués sur document.
      Un seul setInterval pour le chrono de réservation (pas de MutationObserver : écrire le texte déclenche une mutation → boucle infinie).
      Assurance livraison : ON par défaut (auto-ajoutée au 1er rendu du tiroir avec des articles) sauf refus mémorisé (sessionStorage slv_ass_off).
   2) Galerie ↔ teintes : la fiche n'a pas de sélecteur de variante Horizon (c'est le bloc offre qui gère les teintes), donc un clic sur une
      pastille [data-slv-sw-teinte] ou un choix dans un <select data-slv-variante> fait sauter la galerie (slideshow-component.select) sur
      l'image de la teinte (img alt « Teinte <nom> … »).
   3) Textes LP mascara + LP coffrets (fichiers de 18 KB+, au-dessus de la taille max d'un push API) : retrait de « Luxembourg »
      (pour le moment) et délais = livraison express 3-5 j offerte pour tout le monde (Thomas 29/08). */
(function(){
  if (window.__slvPanier) return;
  var P = {};
  function pad(n){ return n < 10 ? '0' + n : '' + n; }
  function finResa(){
    var k = 'slv_resa_fin'; var fin = Number(sessionStorage.getItem(k) || 0);
    if (!fin || fin < Date.now()) { fin = Date.now() + 10 * 60 * 1000; sessionStorage.setItem(k, String(fin)); }
    return fin;
  }
  function tick(){
    var el = document.querySelector('[data-slv-resa]'); if (!el) return;
    var fin = finResa(); var d = Math.max(0, Math.floor((fin - Date.now()) / 1000));
    var s = pad(Math.floor(d / 60)) + ':' + pad(d % 60);
    if (el.textContent !== s) el.textContent = s;
    autoAssurance();
  }
  var assEnCours = false;
  function autoAssurance(){
    var a = document.querySelector('[data-slv-ass]'); if (!a || a.checked || assEnCours) return;
    if (sessionStorage.getItem('slv_ass_off') === '1') return;
    assEnCours = true; a.checked = true; a.closest('.slv-pn__ass').classList.add('est-on');
    add(a.dataset.slvAss).then(function(){ assEnCours = false; }, function(){ assEnCours = false; });
  }
  function rerender(){
    var ids = ['cart-drawer-section']; var head = document.querySelector('#header-group .shopify-section'); if (head && head.id) ids.push(head.id.replace('shopify-section-', ''));
    return fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + '?sections=' + ids.join(','), { headers: { Accept: 'application/json' } }).then(function(r){ return r.json(); }).then(function(json){
      var html = json['cart-drawer-section'];
      if (html) { var doc = new DOMParser().parseFromString(html, 'text/html'); var neuf = doc.querySelector('cart-drawer-component'); var actuel = document.querySelector('cart-drawer-component'); if (neuf && actuel) actuel.innerHTML = neuf.innerHTML; }
      if (ids[1] && json[ids[1]]) { var d2 = new DOMParser().parseFromString(json[ids[1]], 'text/html'); var nI = d2.querySelector('cart-icon, .header-actions__cart-icon, [ref="cartIcon"]'); var aI = document.querySelector('cart-icon, .header-actions__cart-icon, [ref="cartIcon"]'); if (nI && aI) aI.replaceWith(nI); }
      busy(false); tick();
    });
  }
  function busy(on){ var r = document.querySelector('[data-slv-panier]'); if (r) r.classList.toggle('slv-pn--busy', on); }
  function post(url, body){ return fetchInterne(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) }); }

  /* — Garde-fou CADEAUX (Thomas 03/09) : les cadeaux « offert avec le pack » (sérum, surprise) ne peuvent jamais dépasser
     le nombre de packs présents (packs = mascaras ÷ 2, arrondi en dessous). Un mascara retiré/réduit → cadeaux recalés,
     0 pack → cadeaux retirés. Recalé après chaque modification du panier (tiroir, page /cart Horizon) et au chargement
     (paniers déjà en vrac). Nos propres appels sont marqués (interne) pour ne pas re-déclencher le garde-fou. */
  var PACK = 2, interne = false, fetchOrig = window.fetch;
  function estCadeau(it){ var h = it.handle || ''; return h.indexOf('offert-avec-le-pack') > -1 || (Number(it.price) === 0 && h.indexOf('assurance') < 0); }
  function estMascara(it){ var h = it.handle || ''; return h.indexOf('mascara') > -1 && Number(it.price) > 0; }
  function fetchInterne(url, opt){ interne = true; try { return fetchOrig.call(window, url, opt); } finally { interne = false; } }
  function lireCadeaux(c){
    var masc = 0, cadeaux = [];
    (c.items || []).forEach(function(it){ if (estCadeau(it)) cadeaux.push(it); else if (estMascara(it)) masc += Number(it.quantity) || 0; });
    var max = Math.floor(masc / PACK);
    return cadeaux.filter(function(it){ return Number(it.quantity) > max; }).map(function(it){ return { key: it.key, quantity: max }; });
  }
  /* Une correction à la fois, panier relu entre deux (les clés/lignes peuvent bouger après un retrait), 6 tours max. */
  /* Une seule vérification à la fois : deux gardes lancées ensemble (chargement + fetch) ajoutaient chacune le cadeau → 2 lots (test 28/09). */
  var gardeEnCours = null;
  function garde(tour, change){
    if (!tour) {
      if (gardeEnCours) return gardeEnCours;
      gardeEnCours = garde1(1, false).then(function(r){ gardeEnCours = null; return r; }, function(){ gardeEnCours = null; return false; });
      return gardeEnCours;
    }
    return garde1(tour, change);
  }
  function garde1(tour, change){
    tour = tour || 0; change = change || false;
    if (tour > 6) return Promise.resolve(change);
    return fetchInterne('/cart.js', { headers: { Accept: 'application/json' } }).then(function(r){ return r.json(); }).then(function(c){
      var cp = cadeauPatchs(c);
      if (cp && cp.add) return fetchInterne('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: PATCHS, quantity: 1, properties: { _cadeau: 'CADEAU' } }] }) })
        .then(function(){ return garde(tour + 1, true); });
      if (cp && cp.un) return fetchInterne('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: cp.un, quantity: 1 }) })
        .then(function(){ return garde(tour + 1, true); });
      if (cp && cp.rm) return fetchInterne('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: cp.rm, quantity: 0 }) })
        .then(function(){ return garde(tour + 1, true); });
      var ab = majAB(c);
      if (ab) return fetchInterne('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(ab) })
        .then(function(){ return garde(tour + 1, true); });
      var trop = lireCadeaux(c);
      if (!trop.length) return change;
      return fetchInterne('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: trop[0].key, quantity: trop[0].quantity }) })
        .then(function(){ return garde(tour + 1, true); });
    }).catch(function(){ return change; });
  }
  /* — Cadeau du pop-up (Thomas 28/09) : code CADEAU actif (cookie discount_code) + au moins 2 Mascaras Tubing → le lot de patchs est ajouté
     d'office (propriété _cadeau), la remise CADEAU le passe à 0 € ; repasse sous 2 mascaras → on retire seulement le lot qu'on a ajouté. */
  var PATCHS = 53936179347794;   /* 29/09 (Thomas) : le cadeau du pop-up devient le baume Coco (les patchs alourdissaient le colis : +3,30 € de livraison) */
  var ANCIEN_PATCHS = 53636749525330;
  function cookieCadeau(){ return /(?:^|;\s*)discount_code=CADEAU(?:;|$)/i.test(document.cookie || ''); }
  function codeCadeau(){ return AB === 'B' || cookieCadeau(); }
  /* — TEST A/B panier moyen (Thomas 14/10) : groupe tiré dans snippets/solvea-ab. Groupe B = baume Coco offert avec le TRIO (dès 3 mascaras,
     pop-up ou non) + remise TRIO3 (3 mascaras 49,90 €) ; A/X : rien ne change. Le groupe est noté sur le panier → la commande (_ab_aov). */
  var AB = window.SLV_AB || 'X';
  function seuilBaume(){ return cookieCadeau() ? PACK : 3; }   // test A/B v3 (20/10) : avec CADEAU, baume dès 2 en A ET en B ; sans code, seul le trio B (3) l'a
  function majAB(c){
    var out = {}, faire = false;
    if ((c.item_count || 0) > 0 && (c.attributes || {})._ab_aov !== AB) { out.attributes = { _ab_aov: AB }; faire = true; }
    if (AB === 'B') {
      var masc = 0; (c.items || []).forEach(function(it){ if (tubing(it)) masc += Number(it.quantity) || 0; });
      var avant = (c.discount_codes || []).map(function(d){ return String(d.code || '').toUpperCase(); });
      var apres = avant.filter(function(x){ return x !== 'TRIO3'; });
      if (masc >= 3) { apres.push('TRIO3'); if (apres.indexOf('CADEAU') < 0) apres.push('CADEAU'); }
      else if (!/(?:^|;\s*)discount_code=CADEAU(?:;|$)/i.test(document.cookie || '')) apres = apres.filter(function(x){ return x !== 'CADEAU'; });   // posé par le trio, plus utile
      if (apres.slice().sort().join(',') !== avant.slice().sort().join(',')) { out.discount = apres.join(','); faire = true; }
    }
    return faire ? out : null;
  }
  function tubing(it){ return (it.handle || '').indexOf('mascara-tubing') > -1 && Number(it.price) > 0; }
  function cadeauPatchs(c){
    var vieux = (c.items || []).filter(function(it){ return Number(it.variant_id) === ANCIEN_PATCHS && it.properties && it.properties._cadeau; })[0];
    if (vieux) return { rm: vieux.key };   // paniers d'avant le 29/09 : l'ancien cadeau (patchs) n'est plus offert → retiré, le baume le remplace
    if (!codeCadeau()) return null;
    var masc = 0, ligne = null;
    (c.items || []).forEach(function(it){ if (tubing(it)) masc += Number(it.quantity) || 0; if (Number(it.variant_id) === PATCHS) ligne = it; });
    if (masc >= seuilBaume() && !ligne) return { add: true };
    if (masc < seuilBaume() && ligne && ligne.properties && ligne.properties._cadeau) return { rm: ligne.key };
    if (ligne && ligne.properties && ligne.properties._cadeau && Number(ligne.quantity) > 1) return { un: ligne.key };   // un seul lot offert
    return null;
  }
  function pageCart(){ return !!document.querySelector('cart-items-component'); }
  function gardePuis(changeSiOk){
    return garde().then(function(ch){ if (ch && pageCart()) { window.location.reload(); return new Promise(function(){}); } if (ch || changeSiOk) return rerender(); });
  }
  /* Page /cart (Horizon natif) : ses propres appels /cart/change|update passent par fetch → on recale juste après. */
  window.fetch = function(url, opt){
    var p = fetchOrig.apply(window, arguments);
    var u = typeof url === 'string' ? url : (url && url.url) || '';
    if (!interne && /\/cart\/(change|update|add)(\.js)?(\?|$)/.test(u)) { p.then(function(){ setTimeout(function(){ gardePuis(false); }, 50); }, function(){}); }
    return p;
  };
  function change(line, qty){ busy(true); return post('/cart/change.js', { line: line, quantity: qty }).then(function(){ return garde(); }).then(rerender).catch(function(){ busy(false); }); }
  function add(vid){ busy(true); return post('/cart/add.js', { items: [{ id: Number(vid), quantity: 1 }] }).then(function(){ return garde(); }).then(rerender).catch(function(){ busy(false); }); }
  document.addEventListener('click', function(e){
    if (!e.target.closest || !e.target.closest('[data-slv-panier]')) return;
    var q = e.target.closest('[data-slv-qty]'); var rm = e.target.closest('[data-slv-rm]'); var up = e.target.closest('[data-slv-upadd]');
    if (q) { var li = q.closest('[data-slv-line]'); var cur = parseInt(li.querySelector('.slv-pn__qty span').textContent, 10) || 1; change(Number(li.dataset.slvLine), Math.max(0, cur + Number(q.dataset.slvQty))); }
    else if (rm) { var li2 = rm.closest('[data-slv-line]'); change(Number(li2.dataset.slvLine), 0); }
    else if (up) { add(up.dataset.slvUpadd); }
  });
  document.addEventListener('change', function(e){
    var a = e.target.closest ? e.target.closest('[data-slv-ass]') : null; if (!a) return;
    a.closest('.slv-pn__ass').classList.toggle('est-on', a.checked);
    if (a.checked) { sessionStorage.removeItem('slv_ass_off'); add(a.dataset.slvAss); }
    else { sessionStorage.setItem('slv_ass_off', '1'); if (Number(a.dataset.slvAssline) > 0) change(Number(a.dataset.slvAssline), 0); }
  });
  document.addEventListener('cart:refresh', function(){ gardePuis(true); });

  /* — Galerie ↔ teintes — */
  function norm(s){ return (s || '').toString().trim().toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); }
  function galerieVers(nom){
    var g = document.querySelector('media-gallery'); if (!g) return;
    var sc = g.querySelector('slideshow-component'); if (!sc || typeof sc.select !== 'function') return;
    var slides = Array.prototype.slice.call(g.querySelectorAll('slideshow-slide'));
    var n = norm(nom); var idx = -1;
    for (var i = 0; i < slides.length; i++) {
      var im = slides[i].querySelector('img'); var alt = norm(im ? im.getAttribute('alt') : '');
      if (alt.indexOf('teinte ' + n) === 0 || alt.indexOf('colore ' + n) === 0 || alt.indexOf('color ' + n) === 0) { idx = i; break; }
    }
    if (idx < 0 && (n === 'noir intense' || n === 'nero intenso' || n === 'negro intenso')) idx = 0;
    if (idx < 0) return;
    try { sc.select(idx); } catch (e) { try { sc.select(idx, null); } catch (e2) {} }
    var page = document.querySelector('.page-wrapper');
    if (window.innerWidth < 990 && page) { var y = g.getBoundingClientRect().top + page.scrollTop - 90; if (g.getBoundingClientRect().top < 0) page.scrollTo({ top: y, behavior: 'smooth' }); }
  }
  document.addEventListener('click', function(e){
    var sw = e.target.closest ? e.target.closest('[data-slv-sw-teinte]') : null; if (!sw) return;
    galerieVers(sw.getAttribute('data-slv-sw-teinte') || sw.getAttribute('title') || sw.textContent);
  });
  document.addEventListener('change', function(e){
    var s = e.target; if (!s || !s.matches || !s.matches('select[data-slv-variante]')) return;
    var opt = s.options[s.selectedIndex]; if (opt) galerieVers(opt.text);
  });
  P.galerieVers = galerieVers;

  /* — Textes LP mascara + coffrets : Luxembourg retiré, livraison express 3-5 j pour tout le monde — */
  function textesLP(){
    document.querySelectorAll('.slv-lp__faq details p, .slv-lp__tri span, .slv-lp__chapeau, .slv-cof__faq details p, .slv-cof__tri span').forEach(function(p){
      var t = p.textContent;
      if (/5 à 8 jours ouvrés, livraison offerte/.test(t)) { p.textContent = 'Livraison suivie offerte : 5 à 9 jours ouvrés en France et en Belgique.'; return; }
      var n = t.replace(', en Belgique ou au Luxembourg', ' ou en Belgique').replace('France, Belgique et Luxembourg', 'France et Belgique').replace(' et Luxembourg', '').replace(' ou au Luxembourg', '');
      if (n !== t) p.textContent = n;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', textesLP); else textesLP();

  P.rerender = rerender; P.add = add; P.change = change; P.init = tick; P.garde = garde;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ gardePuis(false); }); else gardePuis(false);
  window.__slvPanier = P; tick(); setInterval(tick, 1000);
})();
